<script>
import Api from './Api'
import moment from 'moment'

export default {

  data() {
    return {
      carSnapshots: [],
      isLoading: false,

      now: moment(),
      from: moment().subtract(2, 'days'),
      until: moment().add(1, 'day'),
      addDaysOnNextPage: 1
    }
  },

  methods: {
    fetchData() {
      this.isLoading = true
      Api.fetch({filter: true, from: this.from.format('YYYY-MM-DD'), until: this.until.format('YYYY-MM-DD')}, (carSnapshots)=>{
        this.isLoading = false
        this.carSnapshots = carSnapshots.reverse()
      }).catch(()=>{
        this.isLoading = false
      })
    },

    showDateHeader(index) {
      let current = this.carSnapshots[index]
      if (index == 0) {
        return this.$options.filters.toDate(current.occured_at) != this.$options.filters.toDate(this.now)
      }

      let previous = this.carSnapshots[index-1]

      return this.$options.filters.toDate(current.occured_at) != this.$options.filters.toDate(previous.occured_at)
    },

    parseTags(string) {
      if (!string) {return '-'}

      let tags = JSON.parse(string.replace(/=>/g, ':'))
      return tags.map((tag)=>{
        if (!tag.uid) {
          return {uid: tag}
        }
        return tag
      })
    },

    getNextPage() {
      this.addDaysOnNextPage += 1
      this.from.subtract(this.addDaysOnNextPage, 'days')
      this.fetchData()
    }
  },

  computed: {
    lastSnapshot() {
      if (this.carSnapshots.length == 0) { return }
      return this.carSnapshots[this.carSnapshots.length - 1]
    }
  },

  mounted() {
    this.fetchData()
  },

  filters: {
    toDate(s) {
      if (!s) {return '-'}
      return moment(s).format('DD. MMM YYYY')
    },

    toTime(s) {
      if (!s) {return '-'}
      return moment(s).format('HH:mm:ss')
    }
  }

}
</script>

<template>
  <div class="timeline has-margin-auto">
    <br>
    <b-loading :active="isLoading"></b-loading>
    <header class="timeline-header">
      <span class="tag is-primary is-medium">{{ now | toDate }}</span>
    </header>

    <div v-if="carSnapshots.length == 0" class="timeline-item">
      <div class="timeline-content is-fullwidth">
        <p class="blank-slate">
          <b-icon icon="emoticon-sad-outline"></b-icon> <br>
          No events found.
        </p>
      </div>
    </div>
    <div v-else class="timeline-item">
      <div class="timeline-content"></div>
    </div>

    <template v-for="(carSnapshot, index) in carSnapshots">
      <header class="timeline-header" v-if="showDateHeader(index)" :key="`h-${carSnapshot.id}`">
        <span :class="`tag is-primary ${index == 0 ? 'is-medium' : ''}`">{{ carSnapshot.occured_at | toDate }}</span>
      </header>
      <div class="timeline-item" :key="carSnapshot.id">
        <div class="timeline-marker"></div>
        <div class="timeline-content">
          <p class="heading">{{ carSnapshot.occured_at | toTime }}</p>
          <p class="has-text-left" v-for="(tag, index) in parseTags(carSnapshot.card_reader_read_rfid_tags)" :key="`${tag.uid}-${index}`">
            {{ tag.uid }} <span class="tag-type">{{ tag.type }}</span>
          </p>
        </div>
      </div>
    </template>

    <div class="timeline-item">
      <div class="timeline-content"></div>
    </div>

    <div class="timeline-header">
      <span class="tag is-medium is-primary">{{ from | toDate }}</span>
    </div>
    <br>
    <b-button @click="getNextPage" type="is-text" class="has-margin-auto" :loading="isLoading">
      <b-icon icon="chevron-down" size="is-large"></b-icon>
    </b-button>
  </div>
</template>

<style lang="scss">
.timeline {
  max-width: 280px;
}
.tag-type {
  display: block;
  font-size: 12px;
  color: #888;
}
.has-margin-auto {
  margin: auto;
}
.blank-slate {
  padding-top: 80px;
  padding-bottom: 60px;
  color: #888;
  text-align: center;
  padding-right: 50px;
}
.is-fullwidth {
  width: 100%;
}
</style>